import React, { useState } from 'react';
import moment from 'moment';

import { Calendar } from 'react-date-range';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';

import ButtonPrimary from '../ui/ButtonPrimary';

import './index.css';
// import IconCross from '../icons/IconCross';

const DateTimePicker = (props) => {
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(props.time ? props.time : moment().hour(8).minutes(0).seconds(0));
  
  const apply = () => {
    const dateF = date.format('MM/DD/YYYY');
    const timeF = time.format('h:mm a');
    props.onChoseDate({date: dateF, time: timeF});
  }

  const defaultTime = props.time ? props.time : moment().hour(8).minute(0).seconds(0);

  return (
    <div className="date-time-picker__wrapper" onClick={props.closeDateTimePicker}>
      <div className="date-time-picker__body" onClick={(e) => e.stopPropagation()}>
      {/* <span className="modal__close" onClick={props.onClose}><IconCross/></span> */}
        <Calendar
          onChange={(v) => setDate(v)}
          onInit={(v) => setDate(v)}
          minDate={moment()}
          date={props.date ? props.date : null}
        />
        <TimePicker
          onChange={(v) => setTime(v)}
          showSecond={false}
          defaultValue={defaultTime}
          className="xxx"
          format={'h:mm a'}
          use12Hours
          inputReadOnly
          allowEmpty={false}
        />
        <div className="date-time-picker__footer">
          <ButtonPrimary name="Apply" onClick={apply} />
        </div>
      </div>
    </div>
  );
}

export default DateTimePicker;